export default "__VITE_ASSET__c00ef2cb__"